"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseTransform_1 = require("./BaseTransform");
var object_1 = require("../../utils/object");
var SortTransform = /** @class */ (function (_super) {
    __extends(SortTransform, _super);
    function SortTransform() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SortTransform.prototype.execute = function (queryResponse, queryOptions, executionOptions) {
        var response = queryResponse;
        var sortTransformOptions = this.options.sortTransformOptions;
        if (queryResponse) {
            var direction_1 = sortTransformOptions.direction, key_1 = sortTransformOptions.key;
            var filteredList = [];
            var nullList = [];
            // Filters the response for any null or undefined values
            for (var _i = 0, response_1 = response; _i < response_1.length; _i++) {
                var item = response_1[_i];
                var value = key_1 ? object_1.getValueFromDotNotation(key_1, item, null) : item;
                if (value != null && value != undefined) {
                    filteredList.push(item);
                }
                else {
                    nullList.push(item);
                }
            }
            // Sorts the filteredList
            filteredList = filteredList.sort(function (a, b) {
                if (key_1) {
                    a = object_1.getValueFromDotNotation(key_1, a, null);
                    b = object_1.getValueFromDotNotation(key_1, b, null);
                }
                var result;
                if (typeof a === 'number' && typeof b === 'number') {
                    result = a > b ? 1 : -1;
                }
                else {
                    result = a.toString().localeCompare(b.toString());
                }
                if (direction_1 === 'DESC') {
                    result = result * -1;
                }
                return result;
            });
            // Concat's the 2 lists, so the null or undefined values are at the end
            response = filteredList.concat(nullList);
        }
        return response;
    };
    return SortTransform;
}(BaseTransform_1.BaseTransform));
exports.SortTransform = SortTransform;
//# sourceMappingURL=SortTransform.js.map